import { FC } from 'react';
import { Col, Row } from 'reactstrap';
import Icon from '@views/components/icon';

type ToastIconProperties = { icon: string; message: string };

const ToastIcon: FC<ToastIconProperties> = ({ icon, message }) => (
  <Row className="align-items-center">
    <Col md={3}>
      <Icon name={icon} className="ui__toast-icon" />
    </Col>
    <Col md={9}>
      <h6>
        <b>{message}</b>
      </h6>
    </Col>
  </Row>
);
export default ToastIcon;
